import FormItem from "@components/FormItem/FormItem";
import type { VesselNominationOutletContext } from "@features/vessel-nomination/add/constants";
import { FORM_FIELDS } from "@features/vessel-nomination/add/constants";
import type { VesselNominationFormData } from "@features/vessel-nomination/add/schema/vesselNominationFormSchema";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { LANG_BASE } from "../PreArrivalQuestionnaire";

const Confirmation = () => {
  const { t } = useTranslation();
  const { formData, updateFormData } = useOutletContext<VesselNominationOutletContext>();

  return (
    <FormProvider {...formData}>
      <FormItem<VesselNominationFormData, typeof FORM_FIELDS.CONFIRMATION>
        testId="confirmation-input"
        name={FORM_FIELDS.CONFIRMATION}
        type="checkbox"
        label={t(`${LANG_BASE}.fields.confirm-checkbox`)}
        onFieldChange={updateFormData}
      />
    </FormProvider>
  );
};

export default Confirmation;
